import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { StateToProps } from '../../store';
import { useDispatcher, UseStore } from '../../store.decorator';

import { Report } from './models/report.model';
import { powerBiReducer } from './power-bi.reducer';
import { PowerBiState } from './power-bi.state';
import { reload } from './state/reload.action';
import { useSelector } from './store-use-selector';

@Component({
    selector: 'cmps-power-bi-report',
    templateUrl: './power-bi-report.component.html',
})
@TakeUntilDestroy()
@UseStore<PowerBiState>('reports.power-bi', powerBiReducer)
export class PowerBiReportComponent
    implements StateToProps<PowerBiState>, TakeUntilDestroy
{
    state: PowerBiState;

    /** @private */ _reports: Report[];

    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _activatedRoute: ActivatedRoute,
    ) {
        this._reports = [];
    }

    ngOnInit(): void {
        this._activatedRoute.queryParamMap
            .pipe(
                tap((queryParams) => {
                    const reportTypeId = parseInt(queryParams.get('type'));
                    if (reportTypeId != null && !isNaN(reportTypeId)) {
                        useDispatcher(this, reload({ reportTypeId }));
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();

        useSelector<PowerBiState>('reports.power-bi', () => null)
            .pipe(
                tap((state) => {
                    this._reports = state.powerBiReports?.map((report) => ({
                        ...report,
                        url: this._domSanitizer.bypassSecurityTrustResourceUrl(
                            atob(report.iFrameCode),
                        ),
                    }));
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {}
}
